// import { QueryClient } from '@tanstack/react-query';
// import Cookies from 'js-cookie';
// import { client } from './client/client.gen';
// import { useStore } from './store';
// import { showToast } from './lib';

// export const queryClient = new QueryClient({
// 	defaultOptions: {
// 		queries: {
// 			refetchOnWindowFocus: false,
// 			retry: false,
// 			staleTime: 30000,
// 			structuralSharing: false,
// 		},
// 	},
// });

// client.setConfig({ credentials: 'include' });

// client.interceptors.request.use((request) => {
// 	request.headers.set('X-CSRFToken', Cookies.get('csrftoken') ?? '');
// 	return request;
// });

// client.interceptors.response.use(async(response, request) => {
//   if (response.status !== 200) {
//     // Detect request method
//     const requestMethod = request.method; // 'GET', 'POST', 'PUT', etc.
//     const { errors } = useStore.getState()
//     // Clone the response before reading its body to avoid consuming the stream
//     const resData = await response.clone().json()
//     const msgCode = resData?.message || resData?.error
//     // You can now handle different methods differently
//     if (requestMethod === 'POST') {
//       showToast(errors?.[msgCode] || errors?.[msgCode] || `Hệ thống chưa thể thực hiện yêu cầu của bạn: ${msgCode}`)
//     } else if (requestMethod === 'GET') {
//       // Handle GET-specific logic
//     }
//   }
//   return response;
// });

import { QueryClient } from '@tanstack/react-query';
import createFetchClient, { type Middleware } from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { paths } from '@/@types/openapi'; // generated by openapi-typescript
import Cookies from 'js-cookie';

const configMiddleware: Middleware = {
	async onRequest({ request }) {
		// set "foo" header
		request.headers.set('foo', 'bar');
		return request;
	},

	// async onResponse({ response }) {
	// 	const data = await response.clone().json();

	// 	if (data?.status != 'successful' && data?.error_code) {
	// 		// const {updateState} = useStore();
	// 		// errorCallback();
	// 		showMessage(
	// 			lng[data?.error_code]
	// 				? lng[data?.error_code]
	// 				: `${lng.defaultError} [${data?.error_code}]`
	// 		)

	// 		throw new Error(data?.error_code)?.message;
	// 	}

	// 	return undefined;
	// },
};

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
			structuralSharing: false,
		},
	},
});

const fetchClient = createFetchClient<paths>({
	baseUrl: `${window.location.origin}`,
	credentials: 'include',
	headers: {
		'X-CSRFToken': Cookies.get('csrftoken'),
	},
});
fetchClient.use(configMiddleware);
export const $api = createClient(fetchClient);
